<template>
  <div class="tc-container">
    <div class="tc-chart">
      <div ref="myChart" class="myChart"></div>
      <template v-if="item.position === 'left'">
        <img
          class="circle"
          ref="circle"
          src="../../../assets/wifi_images/left-out-border.png"
          alt=""
        />
        <img
          class="circle"
          ref="circle1"
          src="../../../assets/wifi_images/left-in-border.png"
          alt=""
        />
      </template>
      <template v-else>
        <img
          class="circle"
          ref="circle"
          src="../../../assets/wifi_images/right-out-border.png"
          alt=""
        />
        <img
          class="circle"
          ref="circle1"
          src="../../../assets/wifi_images/right-in-border.png"
          alt=""
        />
      </template>
    </div>
  </div>
</template>
<script>
  import 'echarts-liquidfill'

  export default {
    props: {
      item: {
        type: Object,
        default() {
          return Object
        },
      },
    },
    data() {
      return {}
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let that = this
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        let option = (option = {
          backgroundColor: 'rgba(0, 0, 0, 0)',
          title: [
            {
              text: that.item.text,
              x: 42 - that.item.text.length + '%',
              y: '52%',
              textStyle: {
                fontSize: 14,
                fontWeight: '100',
                color: that.item.textColor,
                lineHeight: 16,
                textAlign: 'center',
              },
            },
          ],
          series: [
            {
              type: 'liquidFill',
              radius: '55%',
              center: ['50%', '50%'],
              color: [
                {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: that.item.waveColor[0],
                    },
                    {
                      offset: 1,
                      color: that.item.waveColor[1],
                    },
                  ],
                  globalCoord: false,
                },
              ],
              data: [that.item.val, that.item.val + 0.05], // data个数代表波浪数
              backgroundStyle: {
                color: {
                  type: 'radial', // linear 线性渐变  radial径向渐变
                  x: 0.5, // 0.5为正中心，如果小于渐变中心靠左
                  y: 0.5, // 0.5为正中心，如果小于渐变中心靠上
                  r: 0.8,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(0, 0, 0, 0)', // 0% 处的颜色
                    },
                    {
                      offset: 0.8,
                      color: that.item.shadowColor, // 100% 处的颜色
                    },
                  ],
                },
              },
              label: {
                normal: {
                  textStyle: {
                    fontSize: 20,
                    color: '#fff',
                  },
                },
              },
              outline: {
                // show: false
                borderDistance: 0,
                itemStyle: {
                  borderWidth: 1,
                  borderColor: that.item.borderColor,
                },
              },
            },
          ],
        })
        myChart.setOption(option)
        window.addEventListener('resize', () => {
          myChart.resize()
        })
        // 圆环进入动画
        this.$animejs({
          targets: this.$refs.circle,
          easing: 'easeInQuad',
          scale: [1.5, 1],
          rotate: [360, 0],
          duration: 1000,
        })
        this.$animejs({
          targets: this.$refs.circle1,
          easing: 'easeInQuad',
          scale: [1.5, 1],
          rotate: [-360, 0],
          duration: 1000,
        })
        // 圆环转动
        setTimeout(() => {
          this.$animejs.remove([this.$refs.circle, this.$refs.circle1])
          this.$animejs({
            targets: this.$refs.circle,
            easing: 'linear',
            loop: true,
            rotate: 360,
            duration: 10000,
          })
          this.$animejs({
            targets: this.$refs.circle1,
            easing: 'linear',
            loop: true,
            rotate: -360,
            duration: 10000,
          })
        }, 1000)
      },
    },
    beforeDestroy() {
      this.$animejs.remove([this.$refs.circle, this.$refs.circle1])
    },
  }
</script>
<style lang="scss" scoped>
  .tc-container {
    width: 100%;

    .tc-chart {
      width: 100%;
      height: 9.375vw;
      margin: 0 auto;
      position: relative;

      .myChart {
        width: 100%;
        height: 9.375vw;
      }

      .circle {
        position: absolute;
        z-index: 4;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }
    }
  }
</style>
